module.exports = __webpack_public_path__ + "img/modelshow03-2.48220a8a.png";